export interface ICubicle {
    cubicleId: number;
    name: string;
    providerName: string;
    providerId?: number;
    activeStatusId: number;
    activeStatusName: string;
    loading: boolean;
    accountId?: number;
    assignedName: string;
}